import prettyBytes from 'pretty-bytes'

export default (bytes: number) => prettyBytes(bytes)
